var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgPaymentCard = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Payment_card",
    "data-name": "Payment card",
    className: "cls-1",
    d: "M850,775H150a75,75,0,0,1-75-75V300a75,75,0,0,1,75-75H850a75,75,0,0,1,75,75V700A75,75,0,0,1,850,775ZM150,725H850a25,25,0,0,0,25-25V475H125V700A25,25,0,0,0,150,725ZM850,275H150a25,25,0,0,0-25,25v75H875V300A25,25,0,0,0,850,275ZM212.5,600h50a37.5,37.5,0,0,1,0,75h-50A37.5,37.5,0,0,1,212.5,600Zm175,0h50a37.5,37.5,0,0,1,0,75h-50A37.5,37.5,0,0,1,387.5,600Zm175,0h50a37.5,37.5,0,0,1,0,75h-50A37.5,37.5,0,0,1,562.5,600Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPaymentCard, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/PaymentCard.bb6ccd14.svg";
export { ForwardRef as ReactComponent };